import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetAvatarComponent } from './get-avatar/get-avatar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GetAvatarComponent],
  exports: [GetAvatarComponent]
})
export class NgxGetAvataaarsModule {}
